const menuItems = state => state.menu.items
const sidebarOpened = state => state.app.sidebar.opened
const sidebarClicked = state => state.app.sidebar.clicked
const sidebarHovered = state => state.app.sidebar.hovered
const toggleWithoutAnimation = state => state.app.sidebar.withoutAnimation
const config = state => state.app.config
const palette = state => state.app.config.palette
const isLoading = state => state.app.isLoading
const isLoggedIn = state => state.isLoggedIn
const timeframe = state => state.app.project.timeframe
const projectLoading = state => state.app.project.isLoading
const subscription = state => state.app.subscription
const filterBrandKeys = state => state.app.project.filterBrandKeys

export {
  menuItems,
  toggleWithoutAnimation,
  sidebarOpened,
  sidebarClicked,
  sidebarHovered,
  config,
  palette,
  isLoading,
  isLoggedIn,
  timeframe,
  projectLoading,
  subscription,
  filterBrandKeys
}



// WEBPACK FOOTER //
// ./src/store/getters.js